import { Box, Grid, Typography } from "@mui/material";
import currency from "currency.js";

export default function CustomerPayment(props) {
  const { payment } = props;

  return (
    <Box>
      {payment.subtotal > 0 && (
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="overline" color="textSecondary">
              Subtotal
            </Typography>
          </Grid>
          <Grid item xs={6} align="right">
            <Typography variant="overline" color="textSecondary">
              {currency(payment.subtotal).format()}
            </Typography>
          </Grid>
        </Grid>
      )}
      {payment.discount > 0 && (
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="overline" color="textSecondary">
              Discount
            </Typography>
          </Grid>
          <Grid item xs={6} align="right">
            <Typography variant="overline" color="textSecondary">
              ({currency(payment.discount).format()})
            </Typography>
          </Grid>
        </Grid>
      )}
      {payment.delivery > 0 && (
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="overline" color="textSecondary">
              Delivery
            </Typography>
          </Grid>
          <Grid item xs={6} align="right">
            <Typography variant="overline" color="textSecondary">
              {currency(payment.delivery).format()}
            </Typography>
          </Grid>
        </Grid>
      )}
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Typography variant="overline" color="textSecondary">
            Tip
          </Typography>
        </Grid>
        <Grid item xs={6} align="right">
          <Typography variant="overline" color="textSecondary">
            {currency(payment.tip).format()}
          </Typography>
        </Grid>
      </Grid>
      {payment.platformFee > 0 && (
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <Typography variant="overline" color="textSecondary">
              Convenience Fee
            </Typography>
          </Grid>
          <Grid item xs={6} align="right">
            <Typography variant="overline" color="textSecondary">
              {currency(+payment.platformFee).format()}
            </Typography>
          </Grid>
        </Grid>
      )}
      {payment.salesTax > 0 && (
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <Typography variant="overline" color="textSecondary">
              Sales Tax
            </Typography>
          </Grid>
          <Grid item xs={6} align="right">
            <Typography variant="overline" color="textSecondary">
              {currency(+payment.salesTax).format()}
            </Typography>
          </Grid>
        </Grid>
      )}
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Typography variant="overline">Total</Typography>
        </Grid>
        <Grid item xs={6} align="right">
          <Typography variant="overline">{currency(payment.total).format()}</Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
